import { fonts, colors } from "../../styles";

export default {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {},
  paragraph: {},
  h1: {
    fontFamily: fonts.header,
    color: colors.white,
    fontSize: "2rem",
    margin: "2rem 0 0 0",
  },
  mediaLink: {
    fontFamily: fonts.paragraph,
    fontSize: "1.25rem",
    color: colors.white,
    textDecoration: "underline",
    margin: "1rem 0",
  },
};



// WEBPACK FOOTER //
// ./src/views/Media/styles.js